// extracted by mini-css-extract-plugin
export default {"fadeIn":"ServicesTech_fadeIn__zFFmC","slideIn":"ServicesTech_slideIn__n+Sku","slideInButton":"ServicesTech_slideInButton__Up+3K"};